var React = require('react');

function DdInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"↓"),React.createElement("g",{"id":"Design","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Independents-Landing","transform":"translate(-1168.000000, -358.000000)","fill":"#000000","fillRule":"nonzero"},React.createElement("polygon",{"id":"↓","points":"1171.35176 369.74 1174.55781 366.533945 1171.94648 366.533945 1171.95332 358.693125 1170.7707 358.693125 1170.76387 366.533945 1168.15254 366.533945"})))]);
}

DdInline.defaultProps = {"width":"7px","height":"12px","viewBox":"0 0 7 12","version":"1.1"};

module.exports = DdInline;

DdInline.default = DdInline;
